import {Component, ElementRef, NgZone, OnInit, ViewChild} from '@angular/core';
import {CaregiverService, ModalService, SocketService, UserService} from '../../services';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {toArray} from 'rxjs/operators';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-caregiver-telecare',
  templateUrl: './caregiver-telecare.component.html',
  styleUrls: ['./caregiver-telecare.component.scss']
})
export class CaregiverTelecareComponent implements OnInit {

  public userMe;
  public userMeInter;
  public userMeGuard;
  public form: FormGroup;
  public status;
  public isLoading = true;
  public isLoading2 = true;
  public isLoading3 = true;
  public isLoading4 = true;
  public displayStatus;
  public allStatuses = {1: 'FREE', 2: 'PAUSE', 3: 'OTHER-TASK', 4: 'END', 5: 'TALKING'};
  public statuses = {1: 'FREE', 2: 'PAUSE', 3: 'OTHER-TASK', 4: 'END'};
  public statuses2 = {1: 'FREE', 2: 'PAUSE', 3: 'OTHER-TASK',  4: 'END'};
  public objectKeys = Object.keys;
  public countDownDate;
  public countDownInter;
  public countDownDisplay;
  public caregiversList = [];
  public socketInterval;
  public callInProgress;
  public convAt;
  public convAtInter;
  public convAtDisplay = '00:00:00';
  public callQueue = [];
  public secondLine = false;

  @ViewChild('statusSelect') statusSelect: ElementRef;

  constructor(
    public userService: UserService,
    private caregiverService: CaregiverService,
    private fb: FormBuilder,
    private modalService: ModalService,
    private socketService: SocketService,
    private ngZone: NgZone,
    private translateService: TranslateService
  ) {
    this.userMeInter = setInterval(() => {
      this.userMe = this.userService.getCurrentUser();
      if (this.userMe.hasOwnProperty('role')) {
        clearInterval(this.userMeInter);
        this.userMeGuard = setInterval(() => {
          this.userMe = this.userService.getCurrentUser();
          if (!this.userMe.hasOwnProperty('role')) {
            clearInterval(this.userMeGuard);
          }
        }, 500);
        this.getTelecare();
        this.getCallInProgress();
        this.getCallQueue();
        this.isLoading2 = true;
        this.caregiverService.getCaregiverCaregivers().subscribe(data => {
          this.caregiversList = data;
          this.isLoading2 = false;
        });

          setInterval(() => {
            this.caregiverService.getCaregiverCaregivers().subscribe(data2 => {
              this.caregiversList = data2;
              data2.forEach(status => {
                if (this.status && this.status.hasOwnProperty('status') && parseInt(this.status.seat) === parseInt(status.carePhone)) {
                  this.displayStatus = parseInt(status.status);
                }
              });
              this.caregiversList = data2;
            }, error => {}, () => { this.isLoading2 = false; });
            this.getCallInProgress(false);
          }, 9000);

      }
    }, 250);
  }

  ngOnInit() {
    this.form = this.fb.group({
      'phone': ['', [Validators.required, Validators.pattern('[0-9]{1,15}')]]
    });
    this.socketInterval = setInterval(() => {
      if (this.socketService.isInitialized) {
        clearInterval(this.socketInterval);
        this.ngZone.run(() => {
          this.socketService.addToCall().subscribe(data => {
            if (this.status.seat === data.carePhone) {
              this.callInProgress = data.callObj;
              this.getCallInProgress(false);
            }
          });
          this.socketService.careStatus().subscribe(data => {
            if (this.status.seat === data.carePhone) {
              if (parseInt(data.status) !== 5) {
                this.status.status = parseInt(data.status);
                this.displayStatus = this.status.status;
                // this.statusSelect.nativeElement.value = parseInt(data.status);
                this.getTelecare();
              } else {
                this.status = false;
                this.getTelecare();
              }
            }
          });
          this.socketService.addToQueue().subscribe(data => {
            this.callQueue.unshift({ 'phone_number': data.phoneNumber, 'user_name': data.userName, 'received_at': data.received_at });
          });
          this.socketService.updateQueue().subscribe(data => {
            this.callQueue = JSON.parse(data.queue);
          });
          this.socketService.forceCallUpdate().subscribe(data => {
            this.getCallInProgress();
          });
        });
      }
    }, 250);

    this.getCallQueueInterval()
  }

  getCallInProgress(loading = true) {
    this.isLoading3 = loading;
    this.caregiverService.getAllCallQueue().subscribe(data => {
      this.callQueue = data;
    });
    this.caregiverService.getCallInProgress().subscribe(data => {
      if (data.convData) {
        const sorted = data.convData.sort((a, b) => {
          if (a.name === 'Operator') {
            return -1;
          }
          if (a.name === 'Pacjent') {
            return 0;
          }
          if (a.name === 'Gość') {
            return 1;
          }
        });
        this.callInProgress = sorted;
        this.convAt = data.convAt;
        this.convAtInter = setInterval(() => {
          const now = new Date().getTime();
          if(this.convAt && this.convAt.date) {
            const timeleft = now - new Date(this.convAt.date).getTime();
            this.convAtDisplay = this.getTimerDisplayData(now, timeleft);
          }
        }, 1000);
      } else {
        this.callInProgress = undefined;
        this.convAt = undefined;
        this.convAtDisplay = undefined;
        clearInterval(this.convAtInter);
      }
      this.isLoading3 = false;
    });
  }

  getTelecare() {
    this.isLoading = true;
    this.caregiverService.getTelecare().subscribe(data => {
      this.status = data;
      this.displayStatus = this.status.status;
      if (this.status.hasOwnProperty('started_at')) {
        this.startTimer();
      }
    }, error => {}, () => { this.isLoading = false; });
  }

  getCallQueue() {
    this.isLoading4 = true;
    this.caregiverService.getAllCallQueue().subscribe(data => {
      this.callQueue = data;
    }, error => {}, () => { this.isLoading4 = false; });
  }

  getCallQueueInterval() {
    setInterval(() => {
      this.caregiverService.getAllCallQueue().subscribe(data => {
        this.callQueue = data;
      }, error => {}, () => { this.isLoading4 = false; });
    }, 100000)

  }

  startTelecare() {
    this.form.controls.phone.markAsTouched();
    this.form.controls.phone.updateValueAndValidity();
    this.isLoading = true;
    if (this.form.valid) {
      this.caregiverService.startTelecare(this.form.value, this.secondLine).subscribe(data => {
        if (data === 'used-number') {
          this.modalService.open(this.translateService.instant('TELECARE.NUMBER-ALREADY-IN-USE'));
        } else {
          this.status = data;
          this.displayStatus = this.status.status;
          if (this.status.hasOwnProperty('started_at')) {
            this.startTimer();
          }
        }
      }, error => {}, () => {
        this.isLoading = false;
      });
    } else {
      this.isLoading = false;
    }
  }

  startTimer() {
    this.countDownDate = new Date(this.status.started_at).getTime();
    this.countDownInter = setInterval(() => {
      let now = new Date().getTime();
      let timeleft = now - this.countDownDate;

      if (this.status && this.status.hasOwnProperty('status') && parseInt(this.status.status) !== 1 && parseInt(this.status.status) !== 5) {
        now = new Date(this.status.stopped_at).getTime();
        timeleft = now - this.countDownDate;
        if (this.countDownInter) {
          clearInterval(this.countDownInter);
        }
      }

      this.countDownDisplay = this.getTimerDisplayData(now, timeleft);
    }, 1000);
  }

  getTimerDisplayData(now, timeleft) {
    const hours = Math.floor(timeleft / 1000 / 60 / 60);
    const minutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeleft % (1000 * 60)) / 1000);

    return (hours < 10 ? '0' + hours : hours) + ':' +
      (minutes < 10 ? '0' + minutes : minutes) + ':' +
      (seconds < 10 ? '0' + seconds : seconds);
  }

  changeTelecare() {
    if (parseInt(this.displayStatus) !== parseInt(this.status.status)) {
      this.isLoading = true;
      this.caregiverService.setTelecare(this.displayStatus).subscribe(data => {
        if (data.hasOwnProperty('started_at')) {
          this.status = data;
          if (this.status.hasOwnProperty('started_at')) {
            this.startTimer();
          }
        } else {
          this.status = undefined;
        }
      }, error => {
      }, () => {
        this.isLoading = false;
      });
    }
  }

  removeFromCall(number) {
    this.isLoading3 = true;
    this.caregiverService.removeFromCall(this.status.seat, number).subscribe(data => {
      this.getCallInProgress();
    });
  }

  endCall() {
    this.caregiverService.endCall(this.status.seat).subscribe(data => {
      this.callInProgress = null;
    });
  }

  changeSecondLine() {
    this.secondLine = !this.secondLine;
  }

  changeStatus(status) {
    this.displayStatus = status;
  }

  removeFromQueue(phoneNumber) {
    this.caregiverService.removeFromQueue(phoneNumber).subscribe(data => {
      this.getCallQueue();
    });
  }

  __parseInt(val) {
    return parseInt(val);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/caregiver-telecare/caregiver-telecare.component.ts